"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUSHER_SOCKET_ID = void 0;
exports.PUSHER_SOCKET_ID = "X-Pusher-Socket-ID";
